import { Autocomplete, Box, Button, Drawer, FormControlLabel, Checkbox, Stack, TextField, Tooltip, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import React, { useEffect, useMemo, useState } from 'react'
import { withTranslation } from 'react-i18next';
import { CommonGridToolBarWithFilterTextCustom, CommonPatientDetails } from "../../../../Components/Common Components/CommonComponents";
import '../reports.css';
import { AmountsCard } from '../../../../Components/CommonCards/CommonCards'
import { ImagePaths } from '../../../../Utility/ImagePaths';
import CommonDatePicker from '../../../../Components/Common Components/CommonDatePicker';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { AmountFormat, formatDate } from "../../../../Components/CommonFunctions/CommonFunctions";
import { DateTime } from 'luxon';
import { CurrencySymbol } from '../../../../Utility/Constants';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';
import { foReportsUseNewBillingApis, BILLING_DATA_TOGGLE_EVENT } from '../../../../Utility/BillingDataSourceHelper';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';

const CreditTypeList = [
    {
        label: "Insurance credit",
        value: "Insurance credit"
    }, {
        label:'Corporate credit',
        value: "Corporate credit"
    }
]

function CreditSettlementReports({ t }) {
    const [state, setState] = useState(() => {
        let isNewBilling = foReportsUseNewBillingApis();
        return {
            page: 0,
            pageSize: 10,
            fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            appointmentType: [],
            dateIndex: 1,
            creditAdjustedData: [],
            appointmentTypeCardList: [],
            totalAppointment: null,
            totalAmount: null,
            appointmentTypeList: [],
            FilteredFromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilteredToDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            FilterDatas: {
                "startTime": null,
                "endTime": null,
                "onError": false,
            },
            timeError: false,
            creditType: ['Insurance credit'],
            opSelected: true,
            ipSelected: true,
            selfSelected: true,
            labSelected: isNewBilling ? false : true,
            pharmacySelected: true,
            OtSelected: isNewBilling ? false : true,
            RadiologySelected: (!isNewBilling && localGetItem("Show_Radiology_Bills_In_FO") === "true") ? true : false,
            PharmacyData: [],
            LabData: [],
            patient_name: "",
            uhid: "",
            isLoader: false,
            isErrorMsg: false,
            isErrorMsgText: '',
            FilterOpen: false,
            receiptAmount: null,
            tds: null,
            disAllowance: null,
            receivedAmount: null,
            claimAmount: null,
        }
    });

    const updateState = (obj) => setState(prev => ({ ...prev, ...obj }));

    useEffect(() => {
        let LoggedUserData = JSON.parse(localGetItem("loggedInUserInfo"))
        let pharmaDetails = JSON.parse(JSON.stringify((LoggedUserData?.pharmacy_data)))
        let labDetails = JSON.parse(JSON.stringify((LoggedUserData?.laboratory_data)))
        pharmaDetails?.forEach((item) => (
            item["isChecked"] = true
        ))
        labDetails?.forEach((item) => (
            item["isChecked"] = true
        ))
        updateState({
            PharmacyData: pharmaDetails,
            LabData: labDetails
        });
        setTimeout(() => getCreditAdjustedData({
            ...state,
            PharmacyData: pharmaDetails,
            LabData: labDetails
        }), 0);
    }, []);

    useEffect(() => {
        if (state.creditType) {
            getCreditAdjustedData();
        }
    }, [state.creditType]);

    useEffect(() => {
        const onTgl = () => {
            const nb = foReportsUseNewBillingApis();
            setState(prev => ({
                ...prev,
                labSelected: nb ? false : true,
                OtSelected: nb ? false : true,
                RadiologySelected: (!nb && localGetItem("Show_Radiology_Bills_In_FO") === "true") ? true : false,
            }));
        };
        window.addEventListener(BILLING_DATA_TOGGLE_EVENT, onTgl);
        return () => window.removeEventListener(BILLING_DATA_TOGGLE_EVENT, onTgl);
    }, []);

    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const LoaderFunction = (key) => {
        updateState({
            isLoader: key
        })
    }

    const FilterDate = (from, to, index) => {
        updateState({
            fromDate: from,
            toDate: to,
            dateIndex: index,
            FilterDatas: { ...state.FilterDatas, endTime: null }
        })
    }

    const getCreditAdjustedData = (customState) => {
        const currState = customState || state;
        try {
            let LabId = currState.LabData?.map((item) => item?.laboratory_id)
            let PharmacyId = currState.PharmacyData?.map((item) => item?.pharmacy_id)
            let moduleType = []
            if (currState.opSelected) moduleType.push("op")
            if (currState.ipSelected) moduleType.push("ip")
            if (currState.selfSelected) moduleType.push("self")
            // if (currState.OtSelected) moduleType.push("ot")
            if (currState.RadiologySelected) moduleType.push("radiology")
            if (localGetItem("multiLaboratory") === "true") {
                let selectedLab = currState.LabData?.filter((item) => item?.isChecked);
                LabId = selectedLab?.length > 0 ? selectedLab?.map((item) => item?.laboratory_id) : ""
                if (LabId !== "") moduleType.push("lab")
            } else {
                if (currState.labSelected && PharmacyId !== "") moduleType.push("lab")
            }
            if (localGetItem("multiPharmacy") === "true") {
                let selectedPharmacy = currState.PharmacyData?.filter((item) => item?.isChecked);
                PharmacyId = selectedPharmacy?.length > 0 ? selectedPharmacy?.map((item) => item?.pharmacy_id) : ""
                if (PharmacyId !== "") moduleType.push("pharmacy")
            } else {
                if (currState.pharmacySelected) moduleType.push("pharmacy")
            }
            LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.NEW_CREDIT_PAYMENT_REPORT + `?from_date=${currState.fromDate}&to_date=${currState.toDate}&credit_type=${currState.creditType ? currState.creditType : ''}&module_type=${moduleType}&laboratory_id=${LabId}&pharmacy_id=${PharmacyId}&patient_name=${currState.patient_name}&uhid=${currState.uhid ? currState.uhid : ""}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        updateState({
                            creditAdjustedData: response?.data?.data,
                            totalAmount: response?.data?.total_amount || 0,
                            receiptAmount: response?.data?.total_receipt_amount || 0,
                            tds: response?.data?.total_tds_amount || 0,
                            disAllowance: response?.data?.total_dis_allowance_amount || 0,
                            receivedAmount: response?.data?.total_received_amount || 0,
                            claimAmount: response?.data?.total_claim_amount || 0,
                            FilteredFromDate: currState?.fromDate,
                            FilteredToDate: currState?.toDate,
                            isLoader: false
                        })
                    }
                }).catch((error) => {
                    LoaderFunction(false)
                    if (error?.response?.data?.status === "fail") {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            LoaderFunction(false)
            errorMessage(error.message)
        }
    }

    const printReports = () => {
        try {
            let LabId = state.LabData?.map((item) => item?.laboratory_id)
            let PharmacyId = state.PharmacyData?.map((item) => item?.pharmacy_id)
            let moduleType = []
            if (state.opSelected) moduleType.push("op")
            if (state.ipSelected) moduleType.push("ip")
            if (state.selfSelected) moduleType.push("self")
            // if (state.OtSelected) moduleType.push("ot")
            if (state.RadiologySelected) moduleType.push("radiology")
            if (localGetItem("multiLaboratory") === "true") {
                let selectedLab = state.LabData?.filter((item) => item?.isChecked);
                LabId = selectedLab?.length > 0 ? selectedLab?.map((item) => item?.laboratory_id) : ""
                if (LabId !== "") moduleType.push("lab")
            } else {
                if (state.labSelected && PharmacyId !== "") moduleType.push("lab")
            }
            if (localGetItem("multiPharmacy") === "true") {
                let selectedPharmacy = state.PharmacyData?.filter((item) => item?.isChecked);
                PharmacyId = selectedPharmacy?.length > 0 ? selectedPharmacy?.map((item) => item?.pharmacy_id) : ""
                if (PharmacyId !== "") moduleType.push("pharmacy")
            } else {
                if (state.pharmacySelected) moduleType.push("pharmacy")
            }
            // let params = localGetItem('allow_manual_entry_in_credit_settlement') === 'true' && state?.creditType.includes("Insurance credit") ? (Serviceurls.UPDATED_INSU_PAYMENT_REPORT + `?from_date=${state.fromDate}&to_date=${state.toDate}&credit_type=${state.creditType ? state.creditType : ''}&module_type=${moduleType}&laboratory_id=${LabId}&pharmacy_id=${PharmacyId}&patient_name=${state.patient_name}&uhid=${state.uhid ? state.uhid : ""}&clinic_id=${localGetItem("clinicId")}&export=pdf`) :
            let params = (Serviceurls.NEW_CREDIT_PAYMENT_REPORT + `?from_date=${state.fromDate}&to_date=${state.toDate}&credit_type=${state.creditType ? state.creditType : ''}&module_type=${moduleType}&laboratory_id=${LabId}&pharmacy_id=${PharmacyId}&patient_name=${state.patient_name}&uhid=${state.uhid ? state.uhid : ""}&export_type=pdf`)
            RestAPIService.getAllTwo(params)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                }).catch((error) => {
                    if (error?.response?.data?.status === "fail") {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const SettlementReportExcel = () => {
        try {
            let LabId = state.LabData?.map((item) => item?.laboratory_id)
            let PharmacyId = state.PharmacyData?.map((item) => item?.pharmacy_id)
            let moduleType = []
            if (state.opSelected) moduleType.push("op")
            if (state.ipSelected) moduleType.push("ip")
            if (state.selfSelected) moduleType.push("self")
            if (state.RadiologySelected) moduleType.push("radiology")
            if (localGetItem("multiLaboratory") === "true") {
                let selectedLab = state.LabData?.filter((item) => item?.isChecked);
                LabId = selectedLab?.length > 0 ? selectedLab?.map((item) => item?.laboratory_id) : ""
                if (LabId !== "") moduleType.push("lab")
            } else {
                if (state.labSelected && PharmacyId !== "") moduleType.push("lab")
            }
            if (localGetItem("multiPharmacy") === "true") {
                let selectedPharmacy = state.PharmacyData?.filter((item) => item?.isChecked);
                PharmacyId = selectedPharmacy?.length > 0 ? selectedPharmacy?.map((item) => item?.pharmacy_id) : ""
                if (PharmacyId !== "") moduleType.push("pharmacy")
            } else {
                if (state.pharmacySelected) moduleType.push("pharmacy")
            }
            LoaderFunction(false)
            let params = `?from_date=${state?.fromDate}&to_date=${state?.toDate}&clinic_id=${localGetItem("clinicId")}&export=excel`
            RestAPIService.excelGet(Serviceurls.UPDATED_INSU_PAYMENT_REPORT + params)
                .then((response) => {
                    if (response.data) {
                        var pom = document.createElement('a');
                        var csvContent = response.data; //here we load our csv data 

                        let filename = response.headers["content-disposition"]?.split("filename=")[1]

                        var blob = new Blob([csvContent], { type: 'application/x-www-form-urlencoded; charset=UTF-8' }); // text/csv;charset=utf-8;
                        var url = URL.createObjectURL(blob);
                        pom.href = url;
                        pom.setAttribute('download', filename ? filename : 'Credit Settlement Report.xlsx');
                        pom.click();
                        LoaderFunction(false)
                    }
                }).catch((error) => {
                    LoaderFunction(false)
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            LoaderFunction(false)
            errorMessage(error?.message)
        }
    }

    const handleCheckBox = (e, data, type) => {
        if (type === 'lab') {
            const newLabData = state.LabData.map(item =>
                item.laboratory_id === data.laboratory_id ? { ...item, isChecked: e.target.checked } : item
            );
            updateState({ LabData: newLabData });
        } else if (type === 'pharmacy') {
            const newPharmacyData = state.PharmacyData.map(item =>
                item.pharmacy_id === data.pharmacy_id ? { ...item, isChecked: e.target.checked } : item
            );
            updateState({ PharmacyData: newPharmacyData });
        }
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
        })
    }

    const closeFilter = () => {
        updateState({ FilterOpen: false })
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{t("Filter")}</Typography>
                    <Button onClick={() => { updateState({ FilterOpen: false }) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_date_filter'>
                        <CommonDatePicker
                            FromDate={state.fromDate}
                            ToDate={state.toDate}
                            DateIndex={state.dateIndex}
                            SelectedDates={FilterDate}
                            HideAllMenu={true} />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 20, emed_tid: 'patient_name' }}
                            size='small'
                            label={t("Patient Name")}
                            value={state.patient_name}
                            autoComplete='off'
                            emed_tid={"patient_nameTestID01"}
                            onChange={(e) => {
                                let alpha = CommonValidation.alphabetOnly(e.target.value);
                                if (alpha || e.target.value === "") {
                                    updateState({ patient_name: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <TextField
                            sx={{ width: "20vw" }}
                            inputProps={{ maxLength: 20, emed_tid: 'UHID' }}
                            size='small'
                            label={t("UHID")}
                            value={state.uhid ? state.uhid : ""}
                            autoComplete='off'
                            emed_tid={"UHIDTestID01"}
                            onChange={(e) => {
                                let number = CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value);
                                if (number || e?.target?.value === "") {
                                    updateState({ uhid: e.target.value })
                                }
                            }}
                        />
                    </Box>
                    <Box component={"div"}>
                        <Box className="eMed_Filter_Header">
                            <Typography marginLeft={"1vw"} >Module Type</Typography>
                        </Box>
                        <Box className="eMed_CheckBox_Group">
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={state.opSelected} onChange={(e) => { updateState({ opSelected: e.target.checked }) }} size='small' />} label={t("Out Patient")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={state.ipSelected} onChange={(e) => { updateState({ ipSelected: e.target.checked }) }} size='small' />} label={t("In Patient")} />
                            <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={state.selfSelected} onChange={(e) => { updateState({ selfSelected: e.target.checked }) }} size='small' />} label={t("Self")} />
                            {/* {localGetItem("isNewBilling") === "false" && <>
                                <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={state.OtSelected} onChange={(e) => { updateState({ OtSelected: e.target.checked }) }} size='small' />} label={t("OT")} />
                                <FormControlLabel disabled={localGetItem("Show_Radiology_Bills_In_FO") !== "true"} className='eMed_CheckBoxDiv' control={<Checkbox checked={state.RadiologySelected} onChange={(e) => { updateState({ RadiologySelected: e.target.checked }) }} size='small' />} label={t("Radiology")} />
                            </>} */}
                            {/* {localGetItem('isNewBilling') === "false" ? (
                                localGetItem('multiLaboratory') === "true" ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        {state.LabData?.map((item, i) => (
                                            <FormControlLabel key={item.laboratory_id} className='eMed_CheckBoxDiv' control={<Checkbox checked={item?.isChecked} onChange={(e) => { handleCheckBox(e, item, 'lab') }} size='small' />} label={item?.laboratory_name} />
                                        ))}
                                    </Box>)
                                    : (<FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={state.labSelected} onChange={(e) => { updateState({ labSelected: e.target.checked }) }} size='small' />} label={t("Lab")} />
                                    )) : null} */}
                            {/* {localGetItem('multiPharmacy') === "true" ?
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    {state.PharmacyData?.map((item, i) => (
                                        <FormControlLabel key={item.pharmacy_id} className='eMed_CheckBoxDiv' control={<Checkbox checked={item?.isChecked} onChange={(e) => { handleCheckBox(e, item, 'pharmacy') }} size='small' />} label={item?.pharmacy_name} />
                                    ))}
                                </Box>
                                : <FormControlLabel className='eMed_CheckBoxDiv' control={<Checkbox checked={state.pharmacySelected} onChange={(e) => { updateState({ pharmacySelected: e.target.checked }) }} size='small' />} label={t("Pharmacy")} />
                            } */}
                        </Box>
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            updateState({
                                optionType: [],
                                fromDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                toDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
                                dateIndex: 1,
                                FilterDatas: {
                                    "startTime": null,
                                    "endTime": null,
                                    "onError": false
                                },
                                timeError: false,
                                opSelected: true,
                                ipSelected: true,
                                selfSelected: true,
                                labSelected: true,
                                pharmacySelected: true,
                                patient_name: "",
                                uhid: "",
                                OtSelected: true,
                                RadiologySelected: localGetItem("Show_Radiology_Bills_In_FO") === "true",
                            });
                            setTimeout(() => getCreditAdjustedData(), 0);
                        }}
                        id="eMed_Config_btn">{t("Clear")}</Button>
                    <Button variant='contained' size="small"
                        disabled={state.FilterDatas.startTime ? (state.FilterDatas.startTime && state.FilterDatas.endTime && state.timeError !== true) ? false : true : false}
                        onClick={() => {
                            getCreditAdjustedData()
                            updateState({
                                FilterOpen: false
                            })
                        }}
                        id="eMed_Config_btn">{t("Search")}</Button>
                </Stack>
            </Box>
        )
    }

    const rowsWithSno = state.creditAdjustedData.map((element, index) => ({ ...element, sno: index + 1 }));

    const Insucolumns = [
        {
            field: "patient_name", flex: 0.19, headerName: t("PatientDetails"),
            renderCell: (params) => (
                <Box>
                    <CommonPatientDetails data={params?.row} />
                </Box>
            ), valueGetter: (params) => {
                const name = params.row?.patient_name || "";
                const mobile = params.row?.patient_mobile_number || "";
                const UHID = params.row?.patient_uhid || "";
                return `${name} ${mobile} ${UHID}`;
            }
        },
        {
            field: "payment_date", headerName: t("Payment Date"), flex: 0.08, align: "center", headerAlign: "center",
            renderCell: (params) => (<Box component={'div'}>{params?.row?.payment_date ? params?.row?.payment_date?.length > 30 ?
                <Tooltip placement='top' title={params?.row?.payment_date} arrow><div>{params?.row?.payment_date.slice(0, 30) + "..."}</div></Tooltip> : params?.row?.payment_date : "-"}</Box>)
        },
        {
            field: "module", headerName: t("Credit type"), flex: 0.07, align: "center", headerAlign: "center",
            renderCell: (params) => (<Box component={'div'} sx={{ fontWeight: 600 }}>{params?.row?.module ? params?.row?.module?.length > 20 ?
                <Tooltip placement='top' title={params?.row?.module} arrow><div style={{ fontWeight: 600 }}>{params?.row?.module.slice(0, 18) + "..."}</div></Tooltip> : params?.row?.module : "-"}</Box>)
        },
        {
            field: "description", headerName: t("Description"), flex: 0.14, align: "center", headerAlign: "center",
            renderCell: (params) => (<Box component={'div'} sx={{ fontWeight: 600 }}>{params?.row?.description ? params?.row?.description?.length > 23 ?
                <Tooltip placement='top' title={params?.row?.description} arrow><div style={{ fontWeight: 600 }}>{params?.row?.description.slice(0, 20) + "..."}</div></Tooltip> : params?.row?.description : "-"}</Box>)
        },
        ...(state?.creditType.includes("Corporate credit") ? [] :
            localGetItem('allow_manual_entry_in_credit_settlement') === 'true' && state?.creditType.includes("Insurance credit") ? [
                {
                    field: "bill_amount", headerName: `${t("Total Amount")} (${CurrencySymbol})`, flex: 0.131, type: "number",
                    renderCell: (params) => {
                        let amount = params.row?.bill_amount && AmountFormat(params?.row?.bill_amount).replace(`${CurrencySymbol}`, "");
                        return (<Box component={'div'}>{amount?.length > 30 ?
                            <Tooltip placement='top' title={amount} arrow><div>{amount.slice(0, 30) + "..."}</div></Tooltip> : amount ? amount : "0.00"}</Box>)
                    }
                },
            ] :
                [
                    {
                        field: "total_amount", headerName: `${t("Total Amount")} (${CurrencySymbol})`, flex: 0.131, type: "number",
                        renderCell: (params) => {
                            let amount = params.row?.total_amount && AmountFormat(params?.row?.total_amount).replace(`${CurrencySymbol}`, "");
                            return (<Box component={'div'}>{amount?.length > 30 ?
                                <Tooltip placement='top' title={amount} arrow><div>{amount.slice(0, 30) + "..."}</div></Tooltip> : amount ? amount : "0.00"}</Box>)
                        }
                    },
                ]),
        ...(state?.creditType.includes("Corporate credit") ? [] : [
            {
                field: "claim_amount", headerName: `${t("Claim Amount")} (${CurrencySymbol})`, flex: 0.111, type: "number",
                renderCell: (params) => {
                    let amount = params.row.claim_amount && AmountFormat(params?.row?.claim_amount).replace(`${CurrencySymbol}`, "");
                    return (<Box component={'div'}>{amount?.length > 30 ?
                        <Tooltip placement='top' title={amount} arrow><div>{amount.slice(0, 30) + "..."}</div></Tooltip> : amount ? amount : "0.00"}</Box>)
                }
            },
        ]),
        {
            field: "received_amount", headerName: `${t("Received Amount")} (${CurrencySymbol})`, flex: 0.131, type: "number",
            renderCell: (params) => {
                let amount = params.row.received_amount && AmountFormat(params?.row?.received_amount).replace(`${CurrencySymbol}`, "");
                return (<Box component={'div'}>{amount?.length > 30 ?
                    <Tooltip placement='top' title={amount} arrow><div>{amount.slice(0, 30) + "..."}</div></Tooltip> : amount ? amount : "0.00"}</Box>)
            }
        },
        ...(state?.creditType?.includes("Corporate credit") ? [
             {
                field: "tds", headerName: `${t("TDS")} (${CurrencySymbol})`, flex: 0.110, type: "number",
                renderCell: (params) => {
                    let amount = params.row.tds && AmountFormat(params?.row?.tds).replace(`${CurrencySymbol}`, "");
                    return (<Box component={'div'}>{amount?.length > 30 ?
                        <Tooltip placement='top' title={amount} arrow><div>{amount.slice(0, 30) + "..."}</div></Tooltip> : amount ? amount : "0.00"}</Box>)
                }
            },
        ] : [
            {
                field: "tds", headerName: `${t("TDS")} (${CurrencySymbol})`, flex: 0.110, type: "number",
                renderCell: (params) => {
                    let amount = params.row.tds && AmountFormat(params?.row?.tds).replace(`${CurrencySymbol}`, "");
                    return (<Box component={'div'}>{amount?.length > 30 ?
                        <Tooltip placement='top' title={amount} arrow><div>{amount.slice(0, 30) + "..."}</div></Tooltip> : amount ? amount : "0.00"}</Box>)
                }
            },
            {
                field: "dis_allowance_amount", headerName: `${t("Dis Allowance")} (${CurrencySymbol})`, flex: 0.110, type: "number",
                renderCell: (params) => {
                    let amount = params.row.dis_allowance_amount && AmountFormat(params?.row?.dis_allowance_amount).replace(`${CurrencySymbol}`, "");
                    return (<Box component={'div'}>{amount?.length > 30 ?
                        <Tooltip placement='top' title={amount} arrow><div>{amount.slice(0, 30) + "..."}</div></Tooltip> : amount ? amount : "0.00"}</Box>)
                }
            }
        ]),
    ]

    const gridToolBar = () => {
        let TextArray = [
            { label: "From Date", value: formatDate(state.FilteredFromDate) },
            { label: "To Date", value: formatDate(state.FilteredToDate) },
        ]
        var ExportData = [];
        state.creditAdjustedData?.length > 0 && state.creditAdjustedData.map((item) => {
            const InsuData = {
                "Patient Name": item?.patient_name,
                "UHID": item?.patient_uhid,
                "Mobile": item?.patient_mobile_number,
                "Payment Date": item?.payment_date,
                "Credit Type": item?.module,
                "Description": item?.description,
                "Total Amount": item?.total_amount,
                "Claim Amount": item?.claim_amount,
                "Received Amount": item?.received_amount,
                "TDS": item?.tds,
                "Dis Allowance": item?.dis_allowance_amount,
            };
            const CorpData = {
                "Patient Name": item?.patient_name,
                "UHID": item?.patient_uhid,
                "Mobile": item?.patient_mobile_number,
                "Payment Date": item?.payment_date,
                "Credit Type": item?.module,
                "Description": item?.description,
                "Received Amount": item?.received_amount,
                "TDS": item?.tds,
            };
            ExportData.push(state?.creditType.includes("Corporate credit") ? CorpData : InsuData);
        });
        return (
            <Box>
                <CommonGridToolBarWithFilterTextCustom data={ExportData} title={"Credit Settlement Report"} FilterTextArray={TextArray} filename={"Credit Settlement Report"} />
            </Box>
        )
    }

    return (
        <Box component={'div'} className='eMed_rts_container'>
            <Box component={"div"} className='eMed_Top_Container'>
                <Box component={"div"} className='eMed_Cards_Container'>
                    {/* {AmountsCard(t("Total Amount"), state.receiptAmount)} */}
                    {state?.creditType?.includes("Corporate credit") ? null : AmountsCard(t("Total Amount"), state.totalAmount)}
                    {AmountsCard(t("Claim Amount"), state.claimAmount)}
                    {AmountsCard(t("Received Amount"), state.receivedAmount)}
                    {AmountsCard(t("TDS"), state.tds)}
                    {state?.creditType?.includes("Corporate credit") ? null : AmountsCard(t("Dis Allowance"), state.disAllowance)}
                </Box>
                <Box component={"div"} className='eMed_Action_Container' sx={{ marginRight: "1vw", display: "flex", alignItems: "center" }}>
                    <Box>
                        <Autocomplete
                            clearIcon={false}
                            size='small'
                            options={CreditTypeList.map((item) => (item.value))}
                            getOptionLabel={(option) => (option)}
                            value={state.creditType}
                            onChange={(event, newValue) => {
                                updateState({ creditType: newValue })
                            }}
                            sx={{ width: "15vw", marginRight: "0.5vw" }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t('Credit Type')}
                                />
                            )}
                        />
                    </Box>
                    <Box component={"div"} className='eMed_Filter_Icon_div' sx={{ marginRight: "0.25vw" }}>
                        <Button className='eMed_usrconf_btn' sx={{ mr: "0.5vw" }} onClick={() => { updateState({ FilterOpen: true }) }}>
                            <img src={ImagePaths.Filter.default} alt="filter" className='eMed_action_img' />
                        </Button>
                    </Box>
                    <Button className='eMed_usrconf_btn' onClick={() => { printReports() }}>
                        <img src={ImagePaths.LabPrintIcon.default} alt="print" className='eMed_action_img' />
                    </Button>
                    {/* {state?.creditType.includes("Insurance credit") && localGetItem('allow_manual_entry_in_credit_settlement') === 'true' ? <IconButton sx={{marginLeft:'1vw'}} className='eMed_usrconf_btn' size="small" onClick={() => { SettlementReportExcel() }}>
                        <img src={ImagePaths.ExportIcon.default} alt="upload" className='eMed_action_img' />
                    </IconButton> : null} */}
                </Box>
            </Box>
            <Box component={'div'} className='eMed_rts_table'>
                <DataGrid
                    rows={rowsWithSno}
                    columns={Insucolumns}
                    getRowId={(row) => row.sno}
                    page={state.page}
                    pageSize={state.pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Stack className='eMed_conf_nodata'>
                                {t("NoRecordsFound")}
                            </Stack>
                        )
                    }}
                    onPageChange={(newPage) => { updateState({ page: newPage }) }}
                    onPageSizeChange={(newPageSize) => updateState({ pageSize: newPageSize })}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    disableSelectionOnClick
                    loading={state.isLoader}
                />
            </Box>
            <Drawer
                anchor={'right'}
                open={state.FilterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {state.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={state.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
        </Box>
    )
}

export default withTranslation()(CreditSettlementReports);
